import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { minBreakpointQuery, standardColours } from '../styles';
import { Container } from './ui';
import ServicesNav from './ServicesNav';
import DefaultNav from './DefaultNav';

const StyledMegaMenu = styled.div`
  ${minBreakpointQuery.mlarge`
    margin-top: 80px;
    padding-top: 30px;
    padding-bottom: 50px; 
    background-color: ${standardColours.white};
  `}

  ${minBreakpointQuery.xlarge`
    padding-top: 35px;
    padding-bottom: 60px
  `}

  ${minBreakpointQuery.xxxlarge`
    padding-top: 40px;
    padding-bottom: 70px
  `}
`;

const StyledInner = styled.div``;

const ServicesMegaMenu = ({ services, platforms, cta }) => (
  <ServicesNav services={services} platforms={platforms} cta={cta} />
);

const DefaultMegaMenu = ({ overline, text, items }) => (
  <DefaultNav overline={overline} text={text} items={items} />
);

const MegaMenu = ({
  overline,
  text,
  items: initialItems,
  cta,
  isServices,
  isIndustries,
  ...props
}) => {
  const {
    allDatoCmsService: { services },
    allDatoCmsIndustry: { industries },
    allDatoCmsPlatform: { platforms },
    datoCmsHeader: { link },
  } = useStaticQuery(graphql`
    query MegaMenuQuery {
      allDatoCmsService(sort: { position: ASC }) {
        services: nodes {
          title
          navigationText
          icon {
            url
            alt
          }
          colour {
            hex
          }
          summary {
            value
          }
          ...LinkFragment
        }
      }
      allDatoCmsIndustry(sort: { position: ASC }) {
        industries: nodes {
          title
          image: featuredImage {
            url
            alt
          }
          ...LinkFragment
        }
      }
      allDatoCmsPlatform(
        filter: { root: { eq: true } }
        sort: { position: ASC }
      ) {
        platforms: nodes {
          title
          badge {
            url
            alt
          }
          ...LinkFragment
          subPlatforms: treeChildren {
            title
            position
            ...LinkFragment
          }
        }
      }
      datoCmsHeader {
        link {
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
    }
  `);

  const items = isIndustries ? industries : initialItems;

  return (
    <StyledMegaMenu {...props}>
      <Container>
        <StyledInner>
          {isServices ? (
            <ServicesMegaMenu
              services={services}
              platforms={platforms}
              cta={{
                text: cta.text,
                link: cta.link || link,
              }}
            />
          ) : (
            <DefaultMegaMenu overline={overline} text={text} items={items} />
          )}
        </StyledInner>
      </Container>
    </StyledMegaMenu>
  );
};

export default MegaMenu;
